var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5759 50.3L45.5438 44.2556L45.7323 44.0667C51.3874 37.4556 50.6334 27.4444 44.0357 21.7778C41.2082 19.3222 37.4381 18 33.8566 18C29.144 18 24.8084 20.0778 21.7924 23.4778C16.1373 30.0889 16.8913 40.1 23.4889 45.7667C26.3165 48.2222 29.898 49.5444 33.6681 49.5444C37.4381 49.5444 41.0197 48.2222 43.8472 45.7667L44.0357 45.5778L50.0678 51.6222C50.2563 51.8111 50.4449 52 50.8219 52C51.0104 52 51.3874 51.8111 51.5759 51.6222C52.1414 51.2444 52.1414 50.6778 51.5759 50.3ZM33.8566 47.4667C26.3165 47.4667 20.2844 41.2333 20.2844 33.8667C20.2844 26.3111 26.3165 20.2667 33.8566 20.2667C41.3967 20.2667 47.4288 26.3111 47.4288 33.8667C47.4288 41.4222 41.3967 47.4667 33.8566 47.4667Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2496 33.6778L37.0611 33.4889L37.2496 33.3C38.1921 32.3556 38.5692 31.2222 38.5692 29.9C38.5692 28.5778 38.0036 27.4444 37.0611 26.6889C36.1186 25.9333 34.9876 25.3667 33.8566 25.3667C32.5371 25.3667 31.2175 25.9333 30.4635 26.8778C28.767 28.7667 28.767 31.6 30.4635 33.3L30.652 33.4889L30.275 33.6778C28.013 35 26.505 37.2667 26.505 39.9111C26.505 40.4778 26.882 40.8556 27.4475 40.8556C28.013 40.8556 28.39 40.4778 28.39 39.9111C28.39 37.0778 30.652 34.8111 33.4796 34.8111C36.3071 34.8111 38.5692 37.0778 38.5692 39.9111C38.5692 40.4778 38.9462 40.8556 39.5117 40.8556C40.0772 40.8556 40.4542 40.4778 40.4542 39.9111C41.0197 37.2667 39.5117 35 37.2496 33.6778ZM36.4956 30.0889C36.4956 31.6 35.3646 32.7333 33.8566 32.7333C32.3486 32.7333 31.2175 31.6 31.2175 30.0889C31.2175 28.5778 32.3486 27.4444 33.8566 27.4444C35.1761 27.4444 36.4956 28.7667 36.4956 30.0889Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPost);
export default __webpack_public_path__ + "static/media/Job Post.2b3ce36cd6598ef850192188f973e92a.svg";
export { ForwardRef as ReactComponent };